import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaGlobe,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DropshippingEcommerceStoreSetupInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Dropshipping E-commerce Store Setup in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Launch Your Business</Subheading>}
        heading={
          <Heading>
            Dropshipping{" "}
            <span tw="text-primary-500">E-commerce Store Setup</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in dropshipping e-commerce store
            setup in **DIFC**, Dubai’s premier financial hub. Our expert
            services deliver seamless, high-performing online stores tailored
            for success in the UAE’s thriving market.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1484807352052-23338990c6c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce store visuals
          "https://images.unsplash.com/photo-1580674285054-bed31e145f59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Shipping/logistics visuals
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Digital business working
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why DIFC?</Subheading>}
        heading="Expert Dropshipping Setup in DIFC"
        description="Launch your e-commerce store with confidence in DIFC’s business-friendly environment."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Regulatory Ease",
            description:
              "Benefit from DIFC’s streamlined licensing and 100% foreign ownership.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Market Access",
            description:
              "Tap into UAE’s booming e-commerce market, projected to hit $8B by 2025.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Global Reach",
            description:
              "Leverage DIFC’s logistics for worldwide dropshipping.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Quickly launch with our efficient process.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Stores designed for UAE’s mobile-first shoppers.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success in DIFC’s competitive landscape.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Dropshipping Setup Process"
        description={
          <Description>
            We build your DIFC dropshipping store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your niche and business goals.</li>
              <li>Licensing: Secure DIFC e-commerce trade license.</li>
              <li>Design: Create a user-friendly, branded store.</li>
              <li>
                Integration: Connect with reliable suppliers and platforms.
              </li>
              <li>Testing: Ensure seamless functionality.</li>
              <li>Launch & Support: Go live with ongoing assistance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Online shopping
          "https://images.unsplash.com/photo-1566002181046-b3f5025e8f80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Boxes/dropshipping visuals
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Dropshipping Wins in DIFC"
        description="Our setups drive real results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Tripled revenue for a DIFC fashion store.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Global Expansion",
            description: "Enabled international shipping for a tech retailer.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "95% satisfaction from DIFC entrepreneurs.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Launch?</Subheading>}
        heading="Dropshipping Success in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for expert dropshipping e-commerce store
            setup in DIFC. Build a thriving online business—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1518893494013-481c1d8ed3fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating/business success
          "https://images.unsplash.com/photo-1627634777217-c864268db30f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Dropshipping concept
          "https://images.unsplash.com/photo-1524508762098-fd966ffb6ef9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Online business
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
